// Create a custom format file (e.g., blots/SubmissionPartBlot.ts)
import Quill from "quill";
const Inline = Quill.import("blots/inline");

export class SubmissionPartBlot extends Inline {
  static blotName = "submissionPart";
  static tagName = "span";
  static className = "submission-part";

  static create(value: any) {
    const node = super.create();

    // Handle the value whether it's an object or already has the properties
    const criteriaIdentifier = value?.criteriaIdentifier || value;
    const relevantInstanceIdentifier = value?.relevantInstanceIdentifier;

    node.setAttribute("data-submission-part", "true");

    if (criteriaIdentifier) {
      node.setAttribute("data-criteria-identifier", criteriaIdentifier);
    }

    if (relevantInstanceIdentifier) {
      node.setAttribute("data-relevant-instance", relevantInstanceIdentifier);
    }

    return node;
  }

  static formats(node: HTMLElement) {
    // Return the object that Quill will pass to create()
    const criteriaIdentifier = node.getAttribute("data-criteria-identifier");
    const relevantInstanceIdentifier = node.getAttribute(
      "data-relevant-instance"
    );

    if (criteriaIdentifier && relevantInstanceIdentifier) {
      return {
        criteriaIdentifier,
        relevantInstanceIdentifier,
      };
    }

    return false; // Return false if attributes are missing
  }
}
